function voiceSearch() {
    //Voice Search
    let voiceTrigger = document.getElementById("voice-trigger")
    let searchForm = document.getElementById("search")
    let searchInput = document.getElementById("search-field")

    if (searchForm) {
        /*  set Web Speech API for Chrome or Firefox */
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition
        let recognition = null

        /* Check if browser support Web Speech API, remove the voice trigger if not supported */
        if (SpeechRecognition) {
            voiceTrigger.classList.remove('disabled');
            /* setup Speech Recognition */
            recognition = new SpeechRecognition();
            recognition.interimResults = true;
            recognition.lang = 'ru-RU';
            recognition.addEventListener('result', _transcriptHandler);

            recognition.onerror = function(event) {
                voiceTrigger.classList.remove('active');
                searchInput.setAttribute("placeholder", "Поиск...");
                if(event.error == 'no-speech'){
                    console.log('no-speech')
                }
            }
        } else {
            voiceTrigger.classList.add('disabled');
        }

        document.addEventListener('DOMContentLoaded', (event) => {
            if (SpeechRecognition) {
                voiceTrigger.addEventListener('click', listenStart, false);
            }
        })
    }


    // /* Our listen event */
    function listenStart(e){
        e.preventDefault();
        searchInput.setAttribute("placeholder", "Говорите...");
        voiceTrigger.classList.add('active');
        recognition.start();
    }

    // /* Parse voice input */
    function _parseTranscript(e) {
        return Array.from(e.results).map(function (result) {
            return result[0] }).map(function (result) {
            return result.transcript
        }).join('')
    }

    // /* Convert our voice input into text and submit the form */
    function _transcriptHandler(e) {
        let speechOutput = _parseTranscript(e)
        searchInput.value = speechOutput;
        if (e.results[0].isFinal) {
            searchForm.submit();
            voiceTrigger.classList.remove('active');
            searchInput.setAttribute("placeholder", "Поиск...");
        }
    }

}

module.exports = {voiceSearch}
